export default "__VITE_ASSET__BJ5XhS$I__"